import {Component, EventEmitter, Input, Output} from '@angular/core';
import {JsonPipe, NgFor, NgIf} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {PlannerRepository} from "../../../repositories/planner.repository";
import {ActivatedRoute} from "@angular/router";
import {STEP_STATUS} from "../../../models/enums";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-task-outcome',
  standalone: true,
  imports: [NgFor,NgIf,JsonPipe,FormsModule],
  templateUrl: './task-outcome.component.html',
  styleUrl: './task-outcome.component.css'
})
export class TaskOutcomeComponent {
  isEditing = false;
  toolingId: string | null = "";
  orgiginalText = "";
  @Input() step: any;
  @Output() loadTooling: EventEmitter<void> = new EventEmitter<void>();

  constructor(private plannerRepository: PlannerRepository,private route: ActivatedRoute) {
    if(environment.standalone){
      this.plannerRepository.setUrl(environment.standaloneServiceUrlForPlanner);
    }
    else {
      this.plannerRepository.setUrl(environment.serviceUrl+environment.plannerServiceUrl);
    }
  }

  async ngOnInit(): Promise<void> {
    this.route.paramMap.subscribe(params => {
      this.toolingId = params.get('plannerId');
    });
  }
  toggleEdit() {
    this.isEditing = !this.isEditing;
    if (this.isEditing) {
      this.orgiginalText = this.step.action.rawData;
    }
  }


  save() {
    this.isEditing = false;
  }

  discard() {
    this.isEditing = false;
    this.step.action.rawData = this.orgiginalText;
  }

  next(){
    this.step.stepStatus="USER_FINALIZED";
    if(this.toolingId) {
      this.plannerRepository.patchToolingStep(this.toolingId, this.step.toolingStepId, this.step).subscribe(
        async (toolingStepPatchResponse: any) => {
          console.log(toolingStepPatchResponse);
          this.loadTooling.emit();
        }
      );
    }
  }

    protected readonly STEP_STATUS = STEP_STATUS;
}
